import React from "react";
import "rc-slider/assets/index.css";
import { Field } from "formik";
import commonCurrencies from "ps-shared/models/forms/commonCurrencies.json";
import Select, { OptionTypeBase } from "react-select";
import { SelectOption } from "./FormikSelect";
import { RangeSlider, RangeSliderValue } from "./RangeSlider";

export interface FormikMoneyRangeSliderProps {
  value: RangeSliderValue;
  name: string;
  min: number;
  max: number;
  currencyOptions: SelectOption[];
  currencyValue?: string;
}
export interface FormikMoneyRangeSliderState {
  value: RangeSliderValue;
  currency: OptionTypeBase;
}

export class FormikMoneyRangeSlider extends React.Component<FormikMoneyRangeSliderProps, FormikMoneyRangeSliderState> {
  constructor(props: FormikMoneyRangeSliderProps) {
    super(props);
    console.log(props);
    this.state = {
      value: props.value,
      currency: props.currencyValue
        ? props.currencyOptions.find((opt) => opt.value === props.currencyValue)
        : props.currencyOptions[0],
    };
  }

  public render() {
    return (
      <Field name={this.props.name}>
        {({ form }: { field: any; form: any }) => (
          <>
            <div className="pb-5">
              <RangeSlider
                currency={this.state.currency.value}
                min={this.props.min}
                max={this.props.max}
                value={this.state.value}
                cb={(val: RangeSliderValue): void => {
                  this.setState({ value: val });
                  form.setFieldValue(this.props.name, {
                    min: val.min,
                    max: val.max,
                    currency: this.state.currency.value,
                  });
                }}
              />
            </div>
            Currency:
            <Select
              isMulti={false}
              value={this.state.currency}
              onChange={(opts) => {
                this.setState({
                  currency: opts,
                });
                form.setFieldValue(this.props.name, {
                  min: this.state.value.min,
                  max: this.state.value.max,
                  currency: opts.value,
                });
              }}
              options={commonCurrencies.map((curr) => ({ value: curr, label: curr }))}
            />
          </>
        )}
      </Field>
    );
  }
}
